export var ButtonVariantEnum;
(function (ButtonVariantEnum) {
    ButtonVariantEnum["Primary"] = "primary";
    ButtonVariantEnum["Secondary"] = "secondary";
    ButtonVariantEnum["PrimaryWhite"] = "primary-white";
    ButtonVariantEnum["SecondaryDanger"] = "secondary-danger";
    ButtonVariantEnum["Ghost"] = "ghost";
    ButtonVariantEnum["Text"] = "text";
})(ButtonVariantEnum || (ButtonVariantEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFyaWFudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy92YXJpYW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBLE1BQU0sQ0FBTixJQUFZLGlCQU9YO0FBUEQsV0FBWSxpQkFBaUI7SUFDNUIsd0NBQW1CLENBQUE7SUFDbkIsNENBQXVCLENBQUE7SUFDdkIsbURBQThCLENBQUE7SUFDOUIseURBQW9DLENBQUE7SUFDcEMsb0NBQWUsQ0FBQTtJQUNmLGtDQUFhLENBQUE7QUFDZCxDQUFDLEVBUFcsaUJBQWlCLEtBQWpCLGlCQUFpQixRQU81QiJ9